import React, { useState, useRef, useEffect } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";

const HelpTooltip = ({isTopToolTip,bonusPercentage,lables}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const toggleTooltip = () => {
    setShowTooltip((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      tooltipRef.current.style.zIndex = 999;
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      tooltipRef.current.style.removeProperty('z-index');
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <>
      {showTooltip && <div className="tooltip-overlay" />}
    <div className="tooltip-container-gl" ref={tooltipRef}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="help-icon-gl"
        onClick={toggleTooltip}
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z"
          fill="#767676"
        />
      </svg>

      {showTooltip && (
        <div className="popover-gl bottom-gl fade-in-gl">
          <div className="popover-content-gl">
            {isTopToolTip
              ? (bonusPercentage > 0) ? commonUtil.getLabel(
                lables.eventAccountStatement,
                'accountStatement.summary.tooltip.percentage.text',
                [bonusPercentage]
              ) : commonUtil.getLabel(
                  lables.eventAccountStatement,
                  'accountStatement.summary.tooltip.nobonus.text',
                )
              : commonUtil.getLabel(
                lables.eventAccountStatement,
                'accountStatement.summary.tooltip.withdrawal.text',
              )}
          </div>
          <div className="arrow-gl" />
        </div>
      )}
    </div>
    </>
  );
};

export default HelpTooltip;
